import util from '@bmp-vue/core/api/util'
import Axios from 'axios'

const controller = 'Empresa'

const getToken = () => JSON.parse(localStorage.getItem('user'))?.token;
const url = process.env.VUE_APP_ROOT_API + controller

export default Object.assign({}, util.GetCrud(controller, null), {
  GetAllByUsuario: function (email) {
    const ambiente = window.env.VUE_APP_AMBIENTE === 'default' ? null : window.env.VUE_APP_AMBIENTE
    const dto = { parameters: [{ name: 'email', value: email }, { name: 'ambiente', value: ambiente }] }
    return util.Axios.GetAll(controller + '/GetAllByUsuario', dto)
  },
  GetCustomJSON: function (codigo) {
    return util.Axios.Get(controller + '/GetCustomJSON', codigo)
  },
  GetByAmbiente: function () {
    return util.Axios.Get(controller + '/GetByAmbiente', window.env.VUE_APP_AMBIENTE)
  },
  GetByIdToParceiro: function (codigo) {
    return util.Axios.Get(controller + '/GetByIdToParceiro', codigo)
  },
  GetAllByCodigoPortal: function (codigoPortal) {
    return util.Axios.Get(controller + '/GetAllByCodigoPortal', codigoPortal)
  },
  GetByIdToParceiroSemLoading: function (codigo) {
    const headers = { Authorization: `Bearer ${getToken()}` }
    return Axios.get(url + '/GetByIdToParceiro/' + codigo, { headers }).then(util.ResponseFunctions.HandleResponseBase, util.ResponseFunctions.HandleErrorBase)
  }
})
